import React from 'react';
import { useParams } from 'react-router-dom';

const ProfilePage = () => {
  const { username } = useParams();

  return (
    <div className="profile-page">
      <h1>Profile Page</h1>
      <p>This is a dummy profile page for user: {username}</p>
      <p>In the actual app, this would redirect to the user's profile.</p>
    </div>
  );
};

export default ProfilePage;